import React from "react";
import { Helmet } from "react-helmet";
import '../../styles/lyrics.css';

const TwentyTwoFreestyle = () => {
  return (
    <div>
      <Helmet>
        <title>LYRICS - 22 FREESTYLE</title>
      </Helmet>

      <section class="lyrics-catalog">
        <p style={{fontSize: '50px', color: '#ffffff', lineHeight: '90%', marginBottom: '60px'}}>LYRICS - 22 FREESTYLE</p>
        <div class="lyrics-frames">
        <div class="lyrics">
                [Verse]<br/>
                Meri aawam jo khadi hai saath<br/>
                To kabhi jaake meri aawaj ye dabegi na<br/>
                Laga na sake meri jubaan pe koi bhi lagaam nai<br/>
                Tabhi aaj<br/>
                Mere ye haath ab<br/>
                Hote nakaam nai<br/>
                Likhu jo bhi karu mehsoos mai<br/>
                Bolunga jhooth nai<br/>
                Abhi inhe chaiye saboot<br/>
                To milengey booth me<br/>
                Karunga mai man ki baat<br/>
                To jalegi saaf<br/>
                Lo galti yahape<br/>
                Kardi saaf<br/>
                Sar pe kafan di bandh<br/>
                Bhidne aaye kal ke ladke<br/>
                Mere halwe pan se, inke rang badal gaye<br/>
                Maine kara jo bhi kara khud hi apne bal me<br/>
                Itne saal ruk ke hote dekha sapne sach maine<br/>
                Hai jalgaye talwe raah pe chalte chalte<br/>
                Kabhi chadh shikhar pe lage parvat halke<br/>
                Mere bhadke man pe jara kam dakhal de<br/>
                Mujhe malum hai wakayi me saath ya khilaaf mere uh!<br/>
                Faile abhi tereko malum hai<br/>
                Inko milega kabhi na koi mere muquable<br/>
                Kehene ko pehele to milo kabhi mere ilaake me<br/>
                Din ba din wo hone lage chehre se waakif wo<br/>
                Sarpe chadke hona chahe ghere me shaamil wo<br/>
                Kalpe kalpe lage, mere pairo par aa gire<br/>
                Humshakal ye bangaye par tere se kaabil mai<br/>
                Lad jhagad margaye wo karu dafan mai!<br/>
                <br/>
                Karigar kalamkaar mai khali karunga kalam<br/>
                Ye kare kaale kartoote mai kasam se karu khatam<br/>
                Ye khud hi karte karam jo khode khud hi ki kabar<br/>
                Ye kayar hai khokhle inhe wazan se karu dafan<br/>
                Hai pasand nai mujhe thasan<br/>
                Ye bachengey nai ye vachan hai<br/>
                Bajne ke liye vajeh ni<br/>
                Masle kabhi kush nai<br/>
                Aage badhega dekha nai jayega, hogi jalan<br/>
                Hai Khud hi pe bharosa nai be kidhar hai teri lagan<br/>
                Maine dekha kitni baari maine baate mere baare me karte mere kaano pe padte mere gaano pe marte par
                dikhawe nai karte<br/>
                Bete kaha pe nikal gaye mere aakhri pal me meri sanki<br/>
                Banegi meri manki<br/>
                Kabhi nai haar maani be dekhle meri aakho se<br/>
                Margayi teri bandi<br/>
                Gaane sunke mere wo chad gayi mere sarpe ladki jo phisal gayi karunga mai nai baate kuch<br/>
                Nano to a Chevrolet<br/>
                Tu nai hai mere level pe<br/>
                Duniya maine chooni hai, juniors bhi ab sehmat hai be churi maine chooli hai suni hai meri mehnat ab
                khud hi ye khud hi ke suli pe chadhengey ladhengey marengey sadengey saale mujhe jeet ta dekhe<br/>
                Mai hu King, Mera Raj aur mai cheekhta RAGE me<br/>
                GAUSH bhag leke pele/bhaag leke pehele<br/>
                Jaise cheetah race me<br/>
                Jalne walo ki mai jala dunga Chittah Stage pe<br/>
                Motherfucker<br/>
                Woah!<br/>
                Saase thami nai<br/>
                Baat pe dhyaan de aaj bhi jung meri<br/>
                Aakhri saas tak<br/>
                Lakh ye chahkar khwaab ye aag se rakh kar sake nai<br/>
                Jaan di agar mere saath<br/>
                Khilaaf to bachengey haath ke vaar se kabhi nai<br/>
                Khaas koi vajeh nai<br/>
                Kyu diss dale?<br/>
                Policewale bhi saath to aaj fir bars ki kami nai uh!<br/>
                <br/>
                Chahte rokna kaise bhi wo meri vocal capacity<br/>
                Chokre aise bhi Bhauk rahe, do unhe<br/>
                Chode hue dogle log maine boht pehele waise bhi uh!<br/>
                Get a hold of my agony, I'mma keep getting the casualties casually<br/>
                Loving the queen, that Bohemian Rhapsody<br/>
                Fuck with the king like Bohemia's Rap CD
            </div>
        </div>
    </section>
      

    </div>
  );
};

export default TwentyTwoFreestyle;
